import { render, staticRenderFns } from "./curriculum-manage.vue?vue&type=template&id=5f0c0046&scoped=true"
import script from "./curriculum-manage.vue?vue&type=script&lang=js"
export * from "./curriculum-manage.vue?vue&type=script&lang=js"
import style0 from "./curriculum-manage.vue?vue&type=style&index=0&id=5f0c0046&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c0046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0c0046')) {
      api.createRecord('5f0c0046', component.options)
    } else {
      api.reload('5f0c0046', component.options)
    }
    module.hot.accept("./curriculum-manage.vue?vue&type=template&id=5f0c0046&scoped=true", function () {
      api.rerender('5f0c0046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/curriculum-manage.vue"
export default component.exports